import React, { useState,useRef } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import Page404 from "app/not-found";
import "../../styles/styles.css";

const API_URL = process.env.REACT_APP_API_URL;
const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" },
});

const PageAjouterInfolettre = () => {
    const { user } = useSelector((state) => state.user);
    const [href, setHref] = useState("");;
    const [date, setDate] = useState(getDate());
    const [fichier, setFichier] = useState(null);
    const [titre, setTitre] = useState("");;
    const titreRef = useRef(null); 
   
   
    function getDate() {   
        var date = new Date()
        const month = ["janvier","février","mars","avril","mai","juin","juillet","août","septembre","obtobre","novembre","décembre"];
        let jour = date.getDate();
        let mois =  month[date.getMonth()];
        let annee = date.getFullYear();
        return jour + " " + mois + " " + annee;
    };

    const uploadPDF = async () =>
    {

        if (fichier!==null)
        {
            try 
            {
                alert("Fichier:"+fichier.name);
                const formData = new FormData();
    
                formData.append("image", fichier);
                
                const response = await axiosInstance.post("api/upload", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data", // Override the Content-Type header
                        },
                    });
                return response.data;
            } 
            catch (error) 
            {
                alert("Erreur:"+error);
            }
        }
        else return ("");
    }

    const saveArticle = async () =>
    {
        if (!(document.querySelector("#titre").value==="" ||
            document.querySelector("#date").value===""))
        {
        try 
        {
            const lien = await uploadPDF();
           
            const formData = new FormData();
            formData.append('href', "/pdf/" + document.querySelector("#href").value);
            formData.append('titre', document.querySelector("#titre").value);
            formData.append('html', lien);
            formData.append('image', "/images/infolettre.jpg");
            formData.append('categorie',"Infolettre");
            formData.append('date', document.querySelector("#date").value);
            formData.append('description', "");
            const response = await axiosInstance.post("api/articles/add", formData);
           
            alert("Enregistrement réussi!");
           // window.location.reload();
    
            console.log("Response:"+response);
        }
        catch (error) 
        {
            alert("Erreur:"+error + " Envoie de: "+ fichier.length*2000/1024/1024 + "MB. Limite permise: 4.5MB");
        }
    }
    else
    {
        alert("Vous devez entrer tous les champs");
        return
    }   
    }

    function remove_accents(str) {
        var strAccents = str.split('');
        var strAccentsOut = [];
        var strAccentsLen = strAccents.length;
        var accents =    "ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëÇçðÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž";
        var accentsOut = "AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeCcdDIIIIiiiiUUUUuuuuNnSsYyyZz";
        for (var y = 0; y < strAccentsLen; y++) {
            if (accents.indexOf(strAccents[y]) !== -1) {
                strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1);
            } else
                strAccentsOut[y] = strAccents[y];
        }
        strAccentsOut = strAccentsOut.join('');
    
        return strAccentsOut;
    }
    const titreChange = (e) => 
    {
        e.preventDefault();
        setTitre(()=>e.target.value);
        setHref(()=>remove_accents(e.target.value).replace(/\s/g, '').replace(/[^0-9a-z]/gi, ''));            
    };
  
    const dateChange = (e) => 
    {
        e.preventDefault();
        setDate(()=>e.target.value);
    };
    const fichierChange = (e) => 
    {
        e.preventDefault();
        if (e.target.files) {
            setFichier(e.target.files[0]);
          }
    };

   
    if (!user) return <Page404 />;

    return (
      <div>
        <form name="frm">
        <table>
            <tbody>
                <tr>
                    
                    <td><p>Titre:</p></td>
                    <td>
                        <input ref={titreRef} value={titre} style={{width:"600px"}} type="text" name="titre" id="titre" onChange={titreChange}/>
                    </td>
                    <td><p>Date:</p></td>
                    <td><p><input id="date" name="date" value={date} type="text" onChange={dateChange} /></p></td> 
                </tr>
                <tr>
                    <td><p>Href:</p></td>
                    <td><input style={{width:"600px"}} id="href" name="href" readOnly type="text" value={href}/></td>
                </tr>
                <tr>
                    <td><p>Fichier:</p></td>
                    <td><input style={{width:"600px"}} type="file" accept=".pdf" id="fichier" name="fichier"  onChange={fichierChange} /></td>
                </tr>
                <tr>
                    <td></td>
                    <td>
                    {fichier && (
                        <button type="button"
                        onClick={saveArticle}
                        className="boutonDownload"
                        >Enregistrer</button>
                    )}  
                    </td>
                </tr>           
            </tbody>
        </table>
        </form>  
      </div>
    )
}

export default PageAjouterInfolettre;